import React, {  useEffect,useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css'

import { FaWhatsapp } from "react-icons/fa";


import ScrollToTop from './Webpages/ScrollToTop'

import WebHeader from './Components/WebHeader'
import WebFooter from './Components/WebFooter'
import HomePage from './Webpages/HomePage'
import About from './Webpages/About';
import ProductPage from './Webpages/ProductPage';
import Contact from './Webpages/Contact';
import FAQs from './Webpages/FAQs';
import Blogs from './Webpages/Blogs';
import Blog1 from './Webpages/Blog1';
import Blog2 from './Webpages/Blog2';
import Blog3 from './Webpages/Blog3';
import Blog4 from './Webpages/Blog4';
import Blog5 from './Webpages/Blog5';

import logoarrow from '../src/Assets/Images/aim logo png.png'


// Pages
const App = () => {

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

 
  return (
    <BrowserRouter>
      
        <WebHeader/>
        <div>
          <ScrollToTop/>
        <Routes>

         <Route path="*" name="HomePage" element={<HomePage />} />
         <Route path="/" name="HomePage" element={<HomePage/>} />
         <Route path="/aboutus" name="About" element={<About/>} />
         <Route path="/products" name="ProductPage" element={<ProductPage/>} />
         <Route path="/faqs" name="FAQs" element={<FAQs/>} />
         <Route path="/blog" name="Blogs" element={<Blogs/>} />
         <Route path="/blog1" name="Blog1" element={<Blog1/>} />
         <Route path="/blog2" name="Blog2" element={<Blog2/>} />
         <Route path="/blog3" name="Blog3" element={<Blog3/>} />
         <Route path="/blog4" name="Blog4" element={<Blog4/>} />
         <Route path="/blog5" name="Blog5" element={<Blog5/>} />
         <Route path="/contact" name="Contact" element={<Contact/>} /> 
        </Routes>
        <a
          href="https://api.whatsapp.com/send/?phone=9822980560 &text=Hello%2C&type=phone_number&app_absent=0"
          className="whatsapp-icon"
          target="_blank"
          rel="noopener noreferrer"
          title="Chat with us!"
        >
          <FaWhatsapp />
        </a>
      
        {/* Scroll-To-Top Button */}
        
        {/* {showScroll && (
  <button className="scroll-to-top show" onClick={scrollToTop}>
<PiPaperPlaneFill  />
  </button>
)} */}

{showScroll && (
  <button className="scroll-to-top show" onClick={scrollToTop}>
    <img src={logoarrow} alt="Scroll to top" 
    style={{ width: '30px', height: '30px' }} />
  </button>
)}
        </div>
     <WebFooter/>
      
    </BrowserRouter>
  )
}

export default App
